export const APP_CONFIG = {
  // baseDomain: 'http://127.0.0.1:8300',
  baseDomain: 'https://clapi.xingyun.vn',
  // baseDomain: 'https://clapi-test.xingyun.vn',
  // baseDomain: 'https://clapi-pre.xingyun.vn',
  mediaDomain: 'https://media.xingyun.vn',
  authSetting: {
    tokenName: 'token',
  },
  settings: {
    main_domain: 'https://xingyun.vn',
    firebase_prefix: 'xingyun',
    firebase_storage: 'https://firebasestorage.googleapis.com/v0/b/oee-app-cc5a1.appspot.com/o',
  },
  eventBusAction: {
    disableMenuLeft: 'disableMenuLeft',
    disableHeader: 'disableHeader',
    showHideMenuLeft: 'showHideMenuLeft',
    reloadWithdrawalHistories: 'reloadWithdrawalHistories',
    reloadNotification: 'reloadNotification'
  },
  stateKey: {
    authStore: 'authStore',
    commonStore: 'commonStore',
    cartState: 'cartState',
  },
  sqlDateFormat: 'YYYY-MM-DD hh:mm:ss',
  notifyRefreshTime: 120,
  ORDER_TYPE: {
    order: 1,
    deposit: 2,
    payAuthority: 3
  },
};
